/*=========================================================================================
  File Name: module-supplier-actions.js
  Description: Supplier Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import SupplierAPI from '@/api/SupplierAPI.js';
import DownloadAPI from '@/api/DownloadAPI.js';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
import { NumberRetry, NumberTimeOutRetry } from '@/api/base/base-api';

export default {
	loadSuppliers: async function(context, payload) {
		context.commit('updateSuppliersLoaded', false);
		let res = await httpClient.getAsync({
			url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
			params: payload
		});

		if (res && res.Success) {
			context.commit('updateSuppliers', res);
		}
		context.commit('updateSuppliersLoaded', true);

		// Trả kết quả
		return res.Data;
	},

	getTotalPageAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/total`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalPage', res.Data);
		}
		return 0;
	},

	loadSuppliersCombobox: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
			params: payload
		});

		if (res && res.Success) {
			if (payload.skip == 0) {
				context.commit('deleteSuppliersCombobox', res);
			}
			context.commit('updateSuppliersCombobox', res, payload.skip);
		}

		// Trả kết quả
		return res.Data;
	},

	checkSupplier: async function(context, payload) {
		let res = await httpClient.putAsync(
			{
				url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/checksupplier',
				data: {}
			},
			true
		);
		// Trả kết quả
		return res;
	},

	checkAgainSupplierTaxAuthorityAsync: async function(context, payload) {
		let res = await httpClient.putAsync(
			{
				url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/checkagiansupplier/${payload.id}`,
				data: {}
			},
			true
		);

		if (res && res.Data && res.Success) {
			return res.Data;
		}

		// Trả kết quả
		return res.Data;
	},

	checkOneSupplierAsync: async function(context, payload) {
		let res = await httpClient.putAsync(
			{
				url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/checksupplier/${payload.id}`,
				data: {}
			},
			true
		);

		if (res && res.Data && res.Success) {
			return res.Data;
		}

		// Trả kết quả
		return res.Data;
	},

	loadBusiness: async function(context, payload) {
		let urlApi = `${SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/business/${payload.TaxCode}`;
		if (payload && payload.OrgId) {
			urlApi = `${SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParamCustom(payload.OrgId))}/business/${
				payload.TaxCode
			}`;
		}
		let res = await httpClient.getAsync({
			url: urlApi
		});

		if (res && res.Success) {
			return res.Data;
		}

		return null;
	},

	loadOfficeRepresentive: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/representive-office/${payload.TaxCode}`
			},
			true
		);

		if (res && res.Success) {
			return res.Data;
		}

		return null;
	},

	loadBusinessByIdentify: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/business-info`,
				data: payload
			},
			true
		);

		if (res && res.Success) {
			return res.Data;
		}

		return null;
	},

	getSupplierByID: async function(context, payload) {
		let res = await httpClient.getAsync(
			{ url: `${SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/detail/${payload.Id}` },
			true,
			true
		);
		if (res && res.Success) {
			context.commit('updateSupplier', res.Data);
			return res.Data;
		}
		return null;
	},

	getSupplierByTaxCode: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${payload.TaxCode}`,
				params: { OrgId: payload.OrgId }
			},
			true,
			true
		);
		if (res && res.Success) {
			context.commit('updateSupplier', res.Data);
			return res.Data;
		}
		return null;
	},

	addSupplier: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()),
				data: payload
			},
			true
		);

		return res.data || res;
	},

	editSupplier: async function(context, payload) {
		let res = await httpClient.putAsync(
			{
				url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				data: payload
			},
			true
		);
		return res;
	},

	// Thực hiện lấy sheet file nhập khẩu
	importSheet: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly() + '/importsheet'),
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Xuất khẩu ncc
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	exportSuppliers: async function(context, payload) {
		let fileName = 'Danh_sach_NCC_khach_hang.xlsx';
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exportsuppliers',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	// Thêm mới nhà cung cấp
	insertSupplierAsync: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/insert',
				data: payload
			},
			true
		);
		return res;
	},

	//Lấy ra danh sách nhà cung cấp không tải về  hóa đơn
	getSupplierNotInvoice: async function(context, payload) {
		let result = await httpClient.postAsync(
			{
				url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/nodownlaodinvoice',
				data: payload
			},
			true
		);
	},

	/**
	 * Lấy lịch sử thay đổi trạng thái hoạt động
	 */
	loadHistoryActiveStatus: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/historychangestatus/${payload.TaxCode}`
		});

		if (res && res.Success) {
			return res.Data;
		}
		return null;
	},

	getSupplierRiskAsync: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: SupplierAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/risksupplier`,
			params: payload
		});

		return res && res.Data ? res.Data : 0;
	}
};
